const awsExports = {
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENTID,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      loginWith: {
        email: 'true' // Optional
      }
    }
  }
};

export default awsExports;
